import type { ColDef } from "ag-grid-community";
import React from "react";

import { AdminGrid, denseAdminGridTheme } from "../AdminGrid";
import { buildInsightsColumnDefs } from "./columns";

type InsightsResultsGridProps = {
  rows: Record<string, unknown>[];
  loading?: boolean;
};

export function InsightsResultsGrid({
  rows,
  loading = false,
}: InsightsResultsGridProps) {
  const columnDefs = React.useMemo<ColDef<Record<string, unknown>>[]>(
    () => buildInsightsColumnDefs(rows),
    [rows],
  );

  const defaultColDef = React.useMemo<ColDef>(
    () => ({
      resizable: true,
      sortable: true,
      suppressSizeToFit: true,
      filterParams: { maxNumConditions: 1 },
    }),
    [],
  );

  return (
    <div className="flex flex-col flex-1 min-h-0 min-w-0 border rounded-lg overflow-hidden">
      <AdminGrid<Record<string, unknown>>
        rowData={rows}
        columnDefs={columnDefs}
        theme={denseAdminGridTheme}
        defaultColDef={defaultColDef}
        loading={loading}
        suppressDragLeaveHidesColumns
        alwaysShowHorizontalScroll
        sideBar={{ toolPanels: ["filters"] }}
      />
    </div>
  );
}
